import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ImportProcessStatus } from '../../model/civilianext-data';
import { CivilianextService } from '../../services/civllianext.service';
import { RoleService } from '../../services/role.service';
import { MessageService } from 'primeng/api';
import { interval, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-import-pagamenti',
  templateUrl: './import-pagamenti.component.html',
  styleUrl: './import-pagamenti.component.scss'
})
export class ImportPagamentiComponent implements OnInit, OnDestroy{

  private civilian = inject(CivilianextService);
  public role_service = inject(RoleService);
  private message_service = inject(MessageService);

  private subscribe?: Subscription;

  status?: ImportProcessStatus;
  secondsCounter: Observable<number>;

  constructor (private service: CivilianextService) {
    this.secondsCounter = interval(10000);
  }

  ngOnInit(): void {
    this.loadStatus();

    this.subscribe = this.secondsCounter.subscribe({
      next: (value:number) => {
        this.loadStatus();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscribe?.unsubscribe();
  }

  loadStatus() {
    this.service.getImportPagamentiStatus().subscribe({
      next: (status: ImportProcessStatus)=> {
        this.status=status;
      }
    });
  }

  startSynch() {
    this.civilian.startImportIUV().subscribe({
      next: (status: ImportProcessStatus)=> {
        if (status.started) {
          this.message_service.add({ severity: 'success', summary: 'Operazione completata', detail: 'Importazione avviata' })
        }
      },
      complete: ()=> {
        this.loadStatus();
      }
    });
  }

}
